import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import {
  ZERO_RESULTS,
  NOT_DELIVERABLE,
  NOT_DELIVERABLE_NO_PICKUP,
  EMPTY_STRING
} from 'constants/errorTypes';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const ErrorMessage = styled(Typography, {
  shouldForwardProp: muiPropForwarding('color')
})(({ theme, color }) => ({
  color: color === 'error' ? theme.palette.error.main : color
}));

const Error = ({ status, color }) => {
  let message = '';
  if (status === ZERO_RESULTS) {
    message =
      "Sorry we couldn't find your address. Please select an option from the dropdown.";
  }
  if (status === NOT_DELIVERABLE_NO_PICKUP) {
    message =
      "Sorry, we don't deliver to your address. Please try a different address.";
  }
  if (status === NOT_DELIVERABLE) {
    message =
      "Sorry, we don't deliver to your address. Please switch to Pickup or try a different address.";
  }
  return message ? <ErrorMessage color={color}>{message}</ErrorMessage> : null;
};

// local state in these components is initialized with error: ''

Error.propTypes = {
  color: PropTypes.string,
  status: PropTypes.oneOf([ZERO_RESULTS, NOT_DELIVERABLE, EMPTY_STRING])
};

Error.defaultProps = {
  color: 'error'
};

export default Error;
